import React, { Fragment, useEffect, useState } from "react";

import {useParams} from "react-router-dom";

import {connect} from "react-redux";

import {HandleMedia, ChangeMedia} from "../../store/actions";

import axios from "axios";


import RadioItem from '../../components/radio/RadioItem';

import { Loader } from "../../components/global";

const Radio = ({HandleMedia, ChangeMedia}) => {

    // let {id} = useParams();

    const [reader, setReader] = useState(null);

    // fetch the surah data
    useEffect( () => {


        axios.get(`https://mp3quran.net/api/verse/radios_fa.json`)
            .then( response => {
                response.data.map((item) => (
                    axios.get(`https://www.mp3quran.net/ar/ajax/radio/item?id=${item.ID}`)
                    .then( response2 => {
    
                        item.URL  =response2.data.file
                        item.Name  =response2.data.name
                        
                       
                    }).catch(e => console.log(e, "from here radio Url"))
    
                ))
    
           
                setReader(response);
                
                ChangeMedia(0);
                HandleMedia(response.data);
            }).catch(e => console.log(e, "from here ya"))

    }, [HandleMedia, ChangeMedia])

    return (
        <section className="reader-page page">
            {
                
                reader != null ? (
                    <Fragment>
                        <RadioItem surah={reader} />
                    </Fragment>
                ) : <Loader />
            }
        </section>
    )

}

const mapStateToProps = (state) => {



    return {
        mediaPlaying: state.mediaPlaying
    }

}

export default connect(mapStateToProps, {HandleMedia, ChangeMedia})(Radio);